import { render, staticRenderFns } from "./HomeViewSide.vue?vue&type=template&id=19563b88&"
import script from "./HomeViewSide.vue?vue&type=script&lang=js&"
export * from "./HomeViewSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports